import {
  CURRENT_LOCATION_INFO,
  PICKUP_LOCATION,
  DESTINATION_LOCATION,
  VEHICLE_LIST,
  PICKUPDATE_TIME,
  RETURNDATE_TIME,
  WAY_TYPE,
  CATEGORIES_LIST,
  CART_DATA,
  STORE_TYPE,
  SERVICE_LIST,
  STORE_LOCATION,
  CHECKOUT_NAVIGATION,
  STORE_FLAT_STREET,
  ACCEPT_COOKIES,
  SHOWMODIFY,
  CABBOOK_NAVIGATION,
  SET_STORE_MODAL_POPUP_SHOW
} from "./actionTypes";

const defaultState = {
  currentLocation: {
    lat: "",
    lng: "",
    address: "",
    selectedLocation: "",
    city: "",
    country: "",
    state: "",
    zip_code: "",
    isocode: "",
  },
  categories: [],
  serviceslist: [],
  currency: "",
  cartdata: [],
  amount: {},
  storetype: "",
  storelocation: {
    store_lat: "",
    store_lng: "",
    store_address:"",
    delivery_max_distance: "",
  },
  navigatecheckout: "",
  navigateCabbook:{
      flag:"",
      id:""
  },
  storeFlatstreet: {
    flat_no: "",
    street_name: "",
  },
  pickup: {
    from_place: "",
    from_place_lat: "",
    from_place_lng: "",
  },
  destination: {
    to_place: "",
    to_place_lat: "",
    to_place_lng: "",
    kilometer: 0,
  },
  pickupdate_time: "",
  returndate_time: "",
  vehiclelist: [],
  waytype: {},
  acceptcookies: "",
  showmodify: false,
  modal_common:{
    title:"",
    sub_title:"",
    name:"",
    type:"",
    itemDelete:()=>{}
  }
};

export const reducer = (state = defaultState, action) => {
  const {
    currentLocation,
    type,
    categories,
    cartdata,
    amount,
    storetype,
    serviceslist,
    storelocation,
    navigatecheckout,
    storeFlatstreet,
    pickup,
    destination,
    pickupdate_time,
    returndate_time,
    vehiclelist,
    waytype,
    acceptcookies,
    showmodify,
    navigateCabbook
  } = action;

  switch (type) {
    case CURRENT_LOCATION_INFO:
      return {
        ...state,
        currentLocation: {
          lat: currentLocation?.lat,
          lng: currentLocation?.lng,
          address: currentLocation?.address,
          selectedLocation: currentLocation?.selectedLocation,
          city: currentLocation?.city,
          state: currentLocation?.state,
          country: currentLocation?.country,
          zip_code: currentLocation?.zip_code,
          isocode: currentLocation?.isocode,
        },
      };
    case CATEGORIES_LIST:
      return {
        ...state,
        categories: categories,
      };
    case SERVICE_LIST:
      return {
        ...state,
        serviceslist: serviceslist,
      };
    case CART_DATA:
      return {
        ...state,
        cartdata: cartdata,
        amount: amount,
      };
    case STORE_TYPE:
      return {
        ...state,
        storetype: storetype,
      };
    case STORE_LOCATION:
      return {
        ...state,
        storelocation: {
          store_lat: storelocation.store_lat,
          store_lng: storelocation.store_lng,
          store_address: storelocation.store_address,
          delivery_max_distance: storelocation.delivery_max_distance,
        },
      };
    case CHECKOUT_NAVIGATION:
      return {
        ...state,
        navigatecheckout: navigatecheckout,
      };
    case STORE_FLAT_STREET:
      return {
        ...state,
        storeFlatstreet: {
          flat_no: storeFlatstreet.flat_no,
          street_name: storeFlatstreet.street_name,
        },
      };
    case PICKUP_LOCATION:
      return {
        ...state,
        pickup: {
          from_place: pickup.from_place,
          from_place_lat: pickup.from_place_lat,
          from_place_lng: pickup.from_place_lng,
        },
      };
    case DESTINATION_LOCATION:
      return {
        ...state,
        destination: {
          to_place: destination.to_place,
          to_place_lat: destination.to_place_lat,
          to_place_lng: destination.to_place_lng,
          kilometer: destination.kilometer,
        },
      };
    case VEHICLE_LIST:
      return {
        ...state,
        vehiclelist: vehiclelist,
      };
    case PICKUPDATE_TIME:
      return {
        ...state,
        pickupdate_time: pickupdate_time,
      };
    case RETURNDATE_TIME:
      return {
        ...state,
        returndate_time: returndate_time,
      };
    case WAY_TYPE:
      return {
        ...state,
        waytype: waytype,
      };
    case ACCEPT_COOKIES:
      return {
        ...state,
        acceptcookies: acceptcookies,
      };
    case SHOWMODIFY:
      return {
        ...state,
        showmodify: showmodify,
      };
    case CABBOOK_NAVIGATION:
      return {
         ...state,
         navigateCabbook:{
          flag:navigateCabbook?.flag,
          id:navigateCabbook?.id
         }
      }
    case SET_STORE_MODAL_POPUP_SHOW:
      return {
          ...state,
          modal_common:{
            ...state?.modal_common,
            show:action?.payload?.show,
            title:action?.payload?.title,
            type:"order",
            itemDelete:action?.payload?.itemDelete
          }
      }
    default:
      return state;
  }
};

export default reducer;
